import styled, { css } from 'styled-components';
import { mediasQuery } from '@utils/responsive';

export const Header = styled.header`
  ${({ theme }) => css`
    max-height: 200px;
    opacity: 1;
    position: relative;
    transition: max-height 0.7s cubic-bezier(0.65, 0, 0.35, 1),
      opacity 0.6s cubic-bezier(0.65, 0, 0.35, 1);

    ${mediasQuery.maxMdMin} {
      margin-bottom: ${theme.spacing.km6};
    }
  `}
`;

export const WrapperPositionHeaderFixed = styled.div`
  ${({ theme }) => css`
    position: sticky;
    background: #fff;
    z-index: 4;
    top: 72px;
    padding-right: ${theme.spacing.km1};
    padding-top: ${theme.spacing.km10};
    max-width: 66%;

    @media (min-width: ${theme.breakpoint.lg.minWidth}) and (max-width: ${theme
        .breakpoint.lg.maxWidth}) {
      top: 144px;
    }

    @media screen and (min-width: 1025px) {
      padding-top: 0;
    }

    @media screen and (max-width: 1275px) {
      max-width: 100%;
    }

    ${mediasQuery.maxMdMin} {
      padding-top: ${theme.spacing.km6};
    }
  `}
`;
